import { ControlledRadioButton } from '@@viewCommonComponents/controlled';
import { Message } from '@fasstech/middle-design-system';
import mapOfferNodeOptions from '@@viewHelpers/mapOfferNodeOptions';

const FranchiseRadioSection = ({
  configKey,
  labelKey,
  infoKey,
  name,
  guarantee,
  extraChange,
  form,
  getMiddleText,
  getMiddleBoolean
}) => {
  if (!getMiddleBoolean(configKey)) return null;

  return (
    <div>
      <div className="mr-4">
        <p className="font-bold">{getMiddleText(labelKey)}</p>
        <ControlledRadioButton
          withIndicator={false}
          form={form}
          name={name}
          options={mapOfferNodeOptions(guarantee)}
          extraChange={extraChange}
          data-testid={name.split('.').at(-2)}
          isAlwaysCol
          className={'whitespace-nowrap w-[300px]!'}
          maxCol={4}
        />
      </div>
      <Message variant="info" label={getMiddleText(infoKey)} />
    </div>
  );
};

export default FranchiseRadioSection;
